module.exports = __webpack_public_path__ + "static/media/win-pic-signed-merchandise.29034ef9.png";